
import { LicenciaContenidosEditModel, LicenciasContenidosListItemPaginatedList, LicenciasContenidosSearch, ModelValidationResult, GetTiposLicenciaResponse, ExportFileResult, BurlingtonOperationResult, LicenciasContenidoDeleteMultipleModel, NormalizarLicenciasPorRolMessage, NormalizarLicenciasPorRolResponse, BuscarAnomaliasBurlingtonMessage, BuscarAnomaliasBurlingtonResponse, ExportarAnomaliasBurlingtonMessage, EnviarAnomaliasBurlingtonPorCorreoMessage, EnviarAnomaliasBurlingtonPorCorreoResponse, LimpiarCuentasBurlingtonMessage, LimpiarCuentasBurlingtonResponse } from "../models/dataModels";
import { ApiFetcher } from "../utils/ApiFetcher";
import { IServiceForEdit, IServiceForIndex } from "../utils/base/BaseServices";
import { downloadFileFromBase64Array } from "../utils/ValuesFormatter";

export class LicenciasColegioService
    implements IServiceForIndex<LicenciasContenidosSearch, LicenciasContenidosListItemPaginatedList>, IServiceForEdit<LicenciaContenidosEditModel>
{
    

    search(searchData: LicenciasContenidosSearch): Promise<LicenciasContenidosListItemPaginatedList> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<LicenciasContenidosSearch, LicenciasContenidosListItemPaginatedList>("intranet/colegio/licencias-contenido/search", searchData);
        prom.then(res => {
            res.items.forEach(item => {
                item.fechaPedido = item.fechaPedido == null ? null : new Date(item.fechaPedido);
                item.fechaUltimoAcceso = item.fechaUltimoAcceso == null ? null : new Date(item.fechaUltimoAcceso);
            });
        });
        return prom;
    }

    delete(id: number): Promise<any> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.delete<any>(`intranet/colegio/licencias-contenido/${id}`);
        return prom;
    }


    deleteMultiple(ids: number[]): Promise<any> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<LicenciasContenidoDeleteMultipleModel, any>(`intranet/colegio/licencias-contenido/deleteMultiple`, {
            idsToDelete: ids
        });
        return prom;
    }

    borrarCredenciales(id: number): Promise<boolean> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<any, boolean>(`intranet/colegio/licencias-contenido/${id}/limpiarCredenciales`, null);
        return prom;
    }

    getById(id: string | number): Promise<LicenciaContenidosEditModelEx> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.getByUrl<LicenciaContenidosEditModelEx>(`intranet/colegio/licencias-contenido/${id}`)
            .then(item => {
            this.processEditModel(item);
            return item;
        });
        return prom;
    }

    validate(model: LicenciaContenidosEditModel): Promise<ModelValidationResult> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<LicenciaContenidosEditModel, ModelValidationResult>(`intranet/colegio/licencias-contenido/validate`, model);
        return prom;
    }

    create(model: LicenciaContenidosEditModel): Promise<LicenciaContenidosEditModelEx> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<LicenciaContenidosEditModel, LicenciaContenidosEditModelEx>(`intranet/colegio/licencias-contenido/`, model)
            .then(item => {
                this.processEditModel(item);
                return item;
            });
        return prom;
    }

    update(id: string | number, model: LicenciaContenidosEditModelEx): Promise<LicenciaContenidosEditModel> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.put<LicenciaContenidosEditModel, LicenciaContenidosEditModelEx>(`intranet/colegio/licencias-contenido/${id}`, model)
            .then(item => {
                this.processEditModel(item);
                return item;
            });
        return prom;
    }

    processEditModel(model: LicenciaContenidosEditModelEx) {
        model.fechaPedido = model.fechaPedido == null ? null : new Date(model.fechaPedido.toString());
        model.fechaUltimoAcceso = model.fechaUltimoAcceso == null ? null : new Date(model.fechaUltimoAcceso);
        model.created = model.created == null ? null : new Date(model.created);
        model.modified = model.modified == null ? null : new Date(model.modified);
        model.configuradoProveedor = model.configuradoProveedor == null ? null : new Date(model.configuradoProveedor);
        if (model.logsBurlington != null) {
            model.logsBurlington.forEach((item, index) => {
                item.date = item.date == null ? null : new Date(item.date);
            });
        }
        
        // Migración de Contenidos: el discriminador digital/papel viene ya en el modelo
        // (LicenciasContenidos.EsDigital), no de la presencia del ContenidoId legacy.
        model.boolContenidoDigital = model.esDigital;
    }

    getTiposLicencias(editorial: string): Promise<GetTiposLicenciaResponse> {
        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.getByUrl<GetTiposLicenciaResponse>(`intranet/utils/getTiposLicencias/${editorial}`);
        return prom;
    }

    exportExcel(search: LicenciasContenidosSearch): Promise<any> {
        var url = "intranet/colegio/licencias-contenido/exportExcel";

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<LicenciasContenidosSearch, ExportFileResult>(url, search)
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });
        return promise;
    }

    /**
     * Normaliza las licencias digitales del colegio y curso escolar contra el tipo de usuario:
     * borra las que corresponden al otro rol y las matrículas que se quedan sin ninguna licencia.
     * @param cursoEscolarId Curso escolar cuyas clases se revisan.
     * @param simular Si es true solo devuelve el recuento, sin borrar nada.
     */
    normalizarPorRol(cursoEscolarId: number, simular: boolean): Promise<NormalizarLicenciasPorRolResponse> {
        var apiFetcher = new ApiFetcher();
        return apiFetcher.post<NormalizarLicenciasPorRolMessage, NormalizarLicenciasPorRolResponse>(
            "intranet/colegio/licencias-contenido/normalizarPorRol",
            {
                colegioId: 0,
                cursoEscolarId: cursoEscolarId,
                simular: simular
            });
    }

    /**
     * Busca en las trazas de Burlington del colegio, en el periodo del curso escolar, las huérfanas y las
     * hechas con un email distinto del login de su usuario.
     * @param cursoEscolarId Curso escolar cuyas fechas acotan las trazas.
     */
    anomaliasBurlington(cursoEscolarId: number): Promise<BuscarAnomaliasBurlingtonResponse> {
        var apiFetcher = new ApiFetcher();
        return apiFetcher.post<BuscarAnomaliasBurlingtonMessage, BuscarAnomaliasBurlingtonResponse>(
            "intranet/colegio/licencias-contenido/anomaliasBurlington",
            {
                colegioId: 0,
                cursoEscolarId: cursoEscolarId
            });
    }

    /**
     * Descarga en Excel todas las anomalías de las trazas de Burlington del curso escolar.
     * @param cursoEscolarId Curso escolar cuyas fechas acotan las trazas.
     */
    exportarAnomaliasBurlington(cursoEscolarId: number): Promise<ExportFileResult> {
        var apiFetcher = new ApiFetcher();
        return apiFetcher.post<ExportarAnomaliasBurlingtonMessage, ExportFileResult>(
            "intranet/colegio/licencias-contenido/anomaliasBurlington/exportExcel",
            {
                colegioId: 0,
                cursoEscolarId: cursoEscolarId
            })
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });
    }

    /**
     * Primer paso de la limpieza de Burlington: manda el Excel de anomalías del curso al email del usuario actual.
     * @param cursoEscolarId Curso escolar cuyas fechas acotan las trazas.
     * @returns El destinatario y las trazas que van en el Excel, que se confirman en el segundo paso.
     */
    enviarAnomaliasBurlingtonPorCorreo(cursoEscolarId: number): Promise<EnviarAnomaliasBurlingtonPorCorreoResponse> {
        var apiFetcher = new ApiFetcher();
        return apiFetcher.post<EnviarAnomaliasBurlingtonPorCorreoMessage, EnviarAnomaliasBurlingtonPorCorreoResponse>(
            "intranet/colegio/licencias-contenido/anomaliasBurlington/enviarCorreo",
            {
                colegioId: 0,
                cursoEscolarId: cursoEscolarId,
                email: null
            });
    }

    /**
     * Segundo paso de la limpieza de Burlington: borra allí las cuentas de los emails de las trazas confirmadas,
     * salvo las que son el login de un usuario del colegio.
     * @param cursoEscolarId Curso escolar cuyas fechas acotan las trazas.
     * @param logIds Trazas del Excel enviado en el primer paso.
     */
    limpiarCuentasBurlington(cursoEscolarId: number, logIds: number[]): Promise<LimpiarCuentasBurlingtonResponse> {
        var apiFetcher = new ApiFetcher();
        return apiFetcher.post<LimpiarCuentasBurlingtonMessage, LimpiarCuentasBurlingtonResponse>(
            "intranet/colegio/licencias-contenido/anomaliasBurlington/limpiar",
            {
                colegioId: 0,
                cursoEscolarId: cursoEscolarId,
                logIds: logIds
            });
    }

    syncBurlington(licenciaContenidoId: number): Promise<BurlingtonOperationResult> {

        var url = `intranet/colegio/licencias-contenido/syncBurlington/${licenciaContenidoId}`;

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<any, BurlingtonOperationResult>(url, null)
            .then((result) => {
                
                return result;
            });
        return promise;
    }

    deleteBurlington(email: string, usuarioIdTraza?: number | null): Promise<BurlingtonOperationResult> {

        var url = `intranet/colegio/licencias-contenido/deleteBurlington/${encodeURIComponent(email)}`;
        if (usuarioIdTraza != null) {
            url += `?usuarioIdTraza=${usuarioIdTraza}`;
        }

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<any, BurlingtonOperationResult>(url, null)
            .then((result) => {

                return result;
            });
        return promise;
    }

    syncColegioBurlington(): Promise<BurlingtonOperationResult> {

        var url = `intranet/colegio/licencias-contenido/syncColegioBurlington`;

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<any, BurlingtonOperationResult>(url, null)
            .then((result) => {

                return result;
            });
        return promise;
    }


}


export interface LicenciaContenidosEditModelEx extends LicenciaContenidosEditModel {

    nivelEducativoId?: number;

    boolContenidoDigital: boolean;
}